exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".legend-87212{display:flex;justify-content:center;flex-wrap:wrap;list-style:none;margin-top:14px;padding:0}.legend-87212 .legendItem-23878{display:flex;align-items:center;margin:6px 8px;color:#595959}.legend-87212 .legendItem-23878 .legendIcon-b511a{display:inline-block;width:16px;height:16px;margin-right:6px;border-radius:4px}", ""]);

// Exports
exports.locals = {
	"legend": "legend-87212",
	"legendItem": "legendItem-23878",
	"legendIcon": "legendIcon-b511a"
};